export const transformRequestSendParcelEmail = ({ to, ccEmails, replyTo, subject, body }) => {
  return {
    email: to,
    cc_emails: ccEmails,
    reply_to: replyTo,
    subject,
    message: body,
  }
}
